import {AsyncProcessState} from "../../core/network/async-process/asyncProcessTypes";

export enum AsyncContentStatus {
  ERROR = "error",
  PENDING = "pending",
  SUCCESS = "success"
}
export type AsyncContentError = undefined | AsyncProcessState["error"];

interface AsyncContentProps {
  requestStates: AsyncProcessState[];
  content: (status: AsyncContentStatus, error?: AsyncContentError) => JSX.Element;
  shouldDisplayPendingContentWhenDataIsAvailable?: boolean;
}

function AsyncContent({
  requestStates,
  content,
  shouldDisplayPendingContentWhenDataIsAvailable
}: AsyncContentProps) {
  const isAnyPending = requestStates.some((request) =>
    shouldDisplayPendingContentWhenDataIsAvailable
      ? request.isRequestPending
      : request.isRequestPending && !request.data
  );
  const requestError = requestStates.find((request) => request.error);
  let node = content(AsyncContentStatus.PENDING);

  if (!isAnyPending) {
    if (requestError) {
      node = content(AsyncContentStatus.ERROR, requestError.error);
    } else {
      node = content(AsyncContentStatus.SUCCESS);
    }
  }

  return node;
}

export default AsyncContent;
